"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatLoader = exports.VoiceLoader = exports.ChatMsgLoader = exports.TabLoader = exports.OneChatLoader = exports.CharacterTabLoader = void 0;
const react_1 = require("react");
const jsx_runtime_1 = require("react/jsx-runtime");
const lottie_react_native_1 = __importDefault(require("lottie-react-native"));
const native_base_1 = require("native-base");
const native_1 = __importStar(require("react-content-loader/native"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const user_1 = require("../../store/selectors/user");
const colors_1 = require("../../common/colors");
const constants_1 = require("../../common/constants");
const theme_1 = require("../../helper/theme");
const useDevice_1 = require("../../hooks/useDevice");
//https://github.com/danilowoz/react-content-loader
/**
 *
 * @param props
 * @returns
 */
const OneLoader = (props) => {
    const { isTabOrDesktopDevice } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsxs)(native_1.default, { speed: 1, width: ((isTabOrDesktopDevice ? 550 : theme_1.SCREEN_WIDTH) - 20) / 3, height: isTabOrDesktopDevice ? 100 : 130, viewBox: `0 0 ${(theme_1.SCREEN_WIDTH - 20) / 3} 100`, backgroundColor: colors_1.Colors.PRIMARY_BLUE, foregroundColor: "#fff", ...props, children: [(0, jsx_runtime_1.jsx)(native_1.Rect, { x: "10", y: "110", rx: "3", ry: "3", width: "88", height: "6" }), (0, jsx_runtime_1.jsx)(native_1.Circle, { cx: "45", cy: "45", r: "45" })] }));
};
/**
 *
 * @param props
 * @returns
 */
const CharacterTabLoader = (props) => {
    const width = props?.width / props?.columns;
    const { isTabOrDesktopDevice } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsxs)(native_1.default, { speed: 1, width: width - 10, height: isTabOrDesktopDevice ? 100 : 130, viewBox: `0 0 ${width} 100`, backgroundColor: colors_1.Colors.PRIMARY_BLUE, foregroundColor: "#fff", children: [(0, jsx_runtime_1.jsx)(native_1.Rect, { x: "10", y: "110", rx: "3", ry: "3", width: "88", height: "6" }), (0, jsx_runtime_1.jsx)(native_1.Circle, { cx: "45", cy: "45", r: "45" })] }));
};
exports.CharacterTabLoader = CharacterTabLoader;
/**
 *
 * @param props
 * @returns
 */
const OneChatLoader = (props) => {
    const { isTabOrDesktopDevice } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsxs)(native_1.default, { speed: 2, width: isTabOrDesktopDevice ? theme_1.SCREEN_WIDTH / 1.75 : theme_1.SCREEN_WIDTH, height: 100, viewBox: `0 0 ${isTabOrDesktopDevice ? theme_1.SCREEN_WIDTH / 1.75 : theme_1.SCREEN_WIDTH} 100`, backgroundColor: colors_1.Colors.LIGHT_GRAY, foregroundColor: colors_1.Colors.PRIMARY_BLUE, ...props, children: [(0, jsx_runtime_1.jsx)(native_1.Circle, { cx: "30", cy: "30", r: "30" }), (0, jsx_runtime_1.jsx)(native_1.Rect, { x: "80", y: "17", rx: "4", ry: "4", width: (isTabOrDesktopDevice ? theme_1.SCREEN_WIDTH / 1.75 : theme_1.SCREEN_WIDTH) / 3, height: "13" }), (0, jsx_runtime_1.jsx)(native_1.Rect, { x: "80", y: "40", rx: "3", ry: "3", width: (isTabOrDesktopDevice ? theme_1.SCREEN_WIDTH / 1.75 : theme_1.SCREEN_WIDTH) / 2, height: "10" })] }));
};
exports.OneChatLoader = OneChatLoader;
const Loader = (props) => {
    const { isTabOrDesktopDevice } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsxs)(native_base_1.Stack, { style: {
            opacity: 0.3,
            width: isTabOrDesktopDevice ? 150 : theme_1.SCREEN_WIDTH,
            paddingHorizontal: 25,
            paddingVertical: 0,
        }, children: [(0, jsx_runtime_1.jsxs)(native_base_1.HStack, { marginBottom: 7, children: [(0, jsx_runtime_1.jsx)(OneLoader, { ...props }), (0, jsx_runtime_1.jsx)(OneLoader, { ...props }), (0, jsx_runtime_1.jsx)(OneLoader, { ...props }), isTabOrDesktopDevice && (0, jsx_runtime_1.jsx)(OneLoader, { ...props })] }), (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { marginBottom: 7, children: [(0, jsx_runtime_1.jsx)(OneLoader, {}), (0, jsx_runtime_1.jsx)(OneLoader, {}), (0, jsx_runtime_1.jsx)(OneLoader, {}), isTabOrDesktopDevice && (0, jsx_runtime_1.jsx)(OneLoader, {})] }), (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { marginBottom: 7, children: [(0, jsx_runtime_1.jsx)(OneLoader, {}), (0, jsx_runtime_1.jsx)(OneLoader, {}), (0, jsx_runtime_1.jsx)(OneLoader, {}), isTabOrDesktopDevice && (0, jsx_runtime_1.jsx)(OneLoader, {})] }), (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { children: [(0, jsx_runtime_1.jsx)(OneLoader, {}), (0, jsx_runtime_1.jsx)(OneLoader, {}), (0, jsx_runtime_1.jsx)(OneLoader, {}), isTabOrDesktopDevice && (0, jsx_runtime_1.jsx)(OneLoader, {})] })] }));
};
/**
 *
 * @param props
 * @returns
 */
const TabLoader = (props) => {
    const { isTabOrDesktopDevice } = (0, useDevice_1.useDevice)();
    console.log("props?.width:", props?.width);
    const columnCount = props?.columns || 3;
    return ((0, jsx_runtime_1.jsx)(native_base_1.VStack, { style: {
            opacity: 0.3,
            width: props?.width, // || isTabOrDesktopDevice ? 150 : SCREEN_WIDTH,
            paddingHorizontal: isTabOrDesktopDevice ? 40 : 25,
            paddingVertical: 0,
        }, children: [...Array(4)].map((row, count) => ((0, jsx_runtime_1.jsx)(native_base_1.HStack, { marginBottom: count < 4 ? 7 : 0, space: 1, children: [...Array(columnCount)].map((innerRow, innerCount) => ((0, react_1.createElement)(exports.CharacterTabLoader, { ...props, key: `loader-inner-${innerCount}` }))) }, `loader-${count}`))) }));
};
exports.TabLoader = TabLoader;
const ChatMsgLoader = ({ background }) => {
    const conversation = (0, react_redux_1.useSelector)(user_1.selectConversation);
    return ((0, jsx_runtime_1.jsx)(native_base_1.View, { style: {
            // opacity: 0.3,
            // width: SCREEN_WIDTH,
            padding: 0,
            borderRadius: 20,
            ...(background && { backgroundColor: background }),
            // backgroundColor: "red",
        }, justifyContent: "center", alignItems: "flex-start", paddingX: 0, children: (0, jsx_runtime_1.jsx)(lottie_react_native_1.default, { source: require("../../assets/icons/lottie/loading-dots.json"), autoPlay: true, loop: true, autoSize: true, resizeMode: "cover", style: {
                height: 20,
            } }) }));
};
exports.ChatMsgLoader = ChatMsgLoader;
const VoiceLoader = ({ background }) => {
    return ((0, jsx_runtime_1.jsx)(native_base_1.View, { style: {
            padding: 0,
            height: 40,
            width: 40,
            borderRadius: 20,
            ...(background && { backgroundColor: background }),
        }, justifyContent: "center", alignItems: "center", paddingX: 0, children: (0, jsx_runtime_1.jsx)(lottie_react_native_1.default, { source: require("../../assets/icons/lottie/spinner.json"), autoPlay: true, loop: true, autoSize: true, resizeMode: "cover", style: {
                height: 40,
            } }) }));
};
exports.VoiceLoader = VoiceLoader;
const ChatLoader = () => {
    const { isTabOrDesktopDevice, isPortrait } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsxs)(native_base_1.View, { style: {
            opacity: 0.3,
            width: isTabOrDesktopDevice
                ? isPortrait
                    ? constants_1.TAB_PORTRAIT_SIDEBAR_MAX_WIDTH - 10
                    : constants_1.SIDEBAR_MAX_WIDTH - 20
                : theme_1.SCREEN_WIDTH,
            padding: isTabOrDesktopDevice && isPortrait ? 5 : 20,
            // backgroundColor: "red",
        }, children: [(0, jsx_runtime_1.jsxs)(native_base_1.HStack, { height: 60, alignItems: "center", children: [react_native_1.Platform.OS !== "web" && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(exports.OneChatLoader, {}), (0, jsx_runtime_1.jsx)(exports.OneChatLoader, {})] })), (0, jsx_runtime_1.jsx)(exports.OneChatLoader, {})] }), (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { children: [react_native_1.Platform.OS !== "web" && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(exports.OneChatLoader, {}), (0, jsx_runtime_1.jsx)(exports.OneChatLoader, {})] })), (0, jsx_runtime_1.jsx)(exports.OneChatLoader, {})] })] }));
};
exports.ChatLoader = ChatLoader;
exports.default = Loader;
